<router>
{
    name: 'Notify Stats',
}
</router>
<template lang="pug">
v-container
    PortalNotifyStats
</template>
<script>

import PortalNotifyStats from '@/components/portal/notifyStats';

export default {
    meta: {
        role: 'portalcontact'
    },
    components: {
        PortalNotifyStats
    },
    data () {
        return {

        };
    },
    methods: {

    },
    computed: {
    },
    mounted () {
        window.PortalNotifyStats = this;
    }
};
</script>

<style scoped>
</style>
